export default function AdminHomePage() {
    return (
        <div style={{ padding: 24 }}>
            <h2>Admin Home Page</h2>
            <p>System admin functions</p>
        </div>
    );
}
